import closeButton from "../../assets/icons/closeButton.png";

const Header = ({ onClose }) => (
  <div className="drawer-header">
    <h3 style={{ margin: 0 }}>Warehouse Filter</h3>
    <img onClick={onClose} src={closeButton} alt="Close Icon" />
  </div>
);

export default Header;
